// tslint:disable: jsdoc-format, max-line-length

import { shuffle } from "html-living-framework/lib/Utils/ArrayUtils";
/** Sesame Street: Go Green  */
export const TS01 = "grover_ts01";
/** To start, press the play button! */
export const TS04 = "grover_ts04";
/** Hello there! Did you know, it is important to take care of all of the beautiful nature and living things around us. That is why I, your cute and adorable friend Grover, am here to help show you different things we can do to help take care of our planet!  */
export const IA01 = ["grover_ia01-01", 0.5, "grover_ia01-02", 0.5, "grover_ia01-03", 0.3, "grover_ia01-04"];
/** Come on, let’s get started! */
export const IA02 = "grover_ia02";
/** How should we help take care of our planet first, hmm? */
export const MM01 = "grover_mm01";
/** Trash Blast, with Oscar? */
export const MM02 = "grover_mm02";
/** Lights Out, with Elmo? */
export const MM03 = "grover_mm03";
/** Or Planter Party with Abby? */
export const MM04 = "grover_mm04";
/** What should we do now? */
export const MM05 = "grover_mm05";
/** How would you like to take care of our planet next? */
export const MM06 = "grover_mm06";
/** Where to next? */
export const MM07 = "grover_mm07";
/** Come on, let’s go green! Symbolically of course. I mean, I will remain blue. */
export const MM08 = "grover_mm08";
/** Who is ready to take care of the planet, hmm? */
export const MM09 = "grover_mm09";
/** Go ahead, choose a way to help care for the planet! */
export const MM_TO1 = "grover_mm_to1";
/** <PROMPT> on a button to get started! */
export const MM_TO2 = "grover_mm_to2";
/** To help care for the planet, it is important to keep our neighborhoods clean. That is why we are going to blast all of the trash off into outer space. Here we go, 3, 2, 1… blast off, little trash! */
export const TB_INTRO01 = ["grover_tb_intro01-01", 0.5, "grover_tb_intro01-02", 0.5, "grover_tb_intro01-03", 0.5, "grover_tb_intro01-04", 0.5, "grover_tb_intro01-05", 0.5, "grover_tb_intro01-06", 0.5, "grover_tb_intro01-07"];
/** What!? That’s not how you take care of the planet. You gotta pick up trash and sort it. */
export const TB_INTRO02 = "oscar_tb_intro02";
/** Ah, yes of course. I knew that. (LAUGH) */
export const TB_INTRO03 = "grover_tb_intro03";
/** Let’s suck up all the trash with my handy trash blaster! */
export const TB_COLLECT01 = "oscar_tb_collect01";
/** (SLIMEY SFX) Now, Now don’t be a back seat blaster Slimey. */
export const TB_COLLECT02 = "oscar_tb_collect02";
/** Scram, squirrel! I’m blastin here! */
export const TB_COLLECT03 = "oscar_tb_collect03";
/** Scram! */
export const TB_COLLECT04 = "oscar_tb_collect04";
/** Heh, heh yeah! */
export const TB_COLLECT05 = "oscar_tb_collect05";
/** Hey that’s a good piece of trash. */
export const TB_COLLECT06 = "oscar_tb_collect06";
/** Got one! */
export const TB_COLLECT07 = "oscar_tb_collect07";
/** Heh heh! I love trash! */
export const TB_COLLECT08 = "oscar_tb_collect08";
/** I love the smell of trash in the morning! */
export const TB_COLLECT09 = "oscar_tb_collect09";
/** I’m feeling pretty trashy, myself. (LAUGH) */
export const TB_COLLECT10 = "oscar_tb_collect10";
/** <PROMPT> on the trash to suck it up in my trash blaster! */
export const TB_COLLECT_TO01 = "oscar_tb_collect_to01";
/** Come on, let’s keep picking up trash! */
export const TB_COLLECT_TO02 = "oscar_tb_collect_to02";
/** Hey, don’t forget the <TRASHC>. */
export const TB_COLLECT_TO03 = "oscar_tb_collect_to03";
/** Now that all the trash is collected, it is time to return it to its original owner. (LOOKING AROUND) Okay, who had the can of beans! */
export const TB_SORTINTRO01 = ["grover_tb_sortintro01-01", 0.5, "grover_tb_sortintro01-02", 0.5];
export const TB_SORTINTRO01_3 = "grover_tb_sortintro01-03";
/** Oh no! We’re gonna recycle it. That means getting it processed and turned into something new. */
export const TB_SORTINTRO02 = "oscar_tb_sortintro02";
/** Ah yes of course, I was just about to say recycle it. It is important to recycle as much trash as we can to help keep the planet healthy and clean! */
export const TB_SORTINTRO03 = ["grover_tb_sortintro03-01", 0.5, "grover_tb_sortintro03-02", 0.3, "grover_tb_sortintro03-03", 0.3, "grover_tb_sortintro03-04"];
/** First, we need to sort it into… */
export const TB_SORT01 = "oscar_tb_sort01";
/** Paper… */
export const TB_SORT02 = "oscar_tb_sort02";
/** Compost, that means old food that can help new plants grow… */
export const TB_SORT03 = "oscar_tb_sort03";
/** Or plastic and metal! */
export const TB_SORT04 = "oscar_tb_sort04";
/** Let’s sort this trash! */
export const TB_SORT05 = "oscar_tb_sort05";

/** Where should this go? */
export const TB_SORT07 = "oscar_tb_sort07";
/** <TRASH> goes in paper. */
export const TB_SORT08 = "oscar_tb_sort08";
/** <TRASH> is made of plastic. */
export const TB_SORT08B = "oscar_tb_sort08b";
/** <TRASH> is made of metal. */
export const TB_SORT08C = "oscar_tb_sort08c";
/** <TRASHC> is old food. */
export const TB_SORT08D = "oscar_tb_sort08d";
/** <TRASH> is compost. */
export const TB_SORT08E = "oscar_tb_sort08e";
/** Ah! You must love trash too. */
export const TB_SORT09 = "oscar_tb_sort09";
/** Meh, nice sorting I guess. */
export const TB_SORT10 = "oscar_tb_sort10";
/** Hey, you really know your trash. */
export const TB_SORT11 = "oscar_tb_sort11";
/** All done! You really know your trash! */
export const TB_SORT12 = "oscar_tb_sort12";
/** All done! You can come trash blasting with me anytime! */
export const TB_SORT13 = "oscar_tb_sort13";
/** <TRASHB> is made of plastic. */
export const TB_SORT_WA01 = "oscar_tb_sort_wa01";
/** <TRASHB> is made of paper. */
export const TB_SORT_WA02 = "oscar_tb_sort_wa02";
/** <TRASHB> is made of metal. */
export const TB_SORT_WA03 = "oscar_tb_sort_wa03";
/** <TRASHB> is compost, that means old food. */
export const TB_SORT_WA04 = "oscar_tb_sort_wa04";
/** Try putting it here. */
export const TB_SORT_WA05 = "oscar_tb_sort_wa05";
/** Go ahead, choose a bin for the <TRASHC>. */
export const TB_SORT_TO01 = "oscar_tb_sort_to01";
/** <PROMPT> on a bin. */
export const TB_SORT_TO02 = "oscar_tb_sort_to02";
/** To take care of our planet, it is important to conserve energy like making sure all the lights are out. So everyone please bring all your lamps, nightlights, flashlights out here, please. */
export const LO_INTRO01 = ["grover_lo_intro01-01", 0.3, "grover_lo_intro01-02", 0.3, "grover_lo_intro01-03", 0.3, "grover_lo_intro01-04"];
/** No Grover! It means we have to make sure things are turned off when we’re not using them and only use what we need. */
export const LO_INTRO02 = ["elmo_lo_intro02-01", 0.5, "elmo_lo_intro02-02", 0.3, "elmo_lo_intro02-03", 0.3, "elmo_lo_intro02-04"];
/** Oh, okay. Everyone keep your lamps inside. */
export const LO_INTRO03 = "grover_lo_intro03";
/** Yeah, we’re gonna go inside too, Grover. */
export const LO_INTRO04 = "elmo_lo_intro04";
/** Help Elmo find three things to turn off in Elmo’s <ROOM> */
export const LO01 = "elmo_lo01";
/** Now let’s turn things off in Elmo’s <ROOM> */
export const LO02 = "elmo_lo02";
/** Let’s make sure everything is off in Elmo’s <ROOM> */
export const LO03 = "elmo_lo03";
/** That’s better. */
export const LO04 = "elmo_lo04";
/** It’s important to make sure things are off when they’re not in use. */
export const LO05 = "elmo_lo05";
/** Lights out! */
export const LO06 = "elmo_lo06";
/** That will help Elmo save energy. */
export const LO07 = "elmo_lo07";
/** Way to turn that faucet all the way off! */
export const LO08 = "elmo_lo08";
/** No more drips here. */
export const LO09 = "elmo_lo09";
/** (GIGGLES) */
export const LO12 = "elmo_lo12";
/** Come on, let’s turn things off! */
export const LO13 = "elmo_lo13";
/** All done! Thanks for helping Elmo turn things off and save energy! */
export const LO14 = "elmo_lo14";
/** All done! Now Elmo’s house is not wasting energy or water! */
export const LO15 = "elmo_lo15";
/** <PROMPT> to turn something off. */
export const LO_TO01 = "elmo_lo_to01";
/** Elmo wonders what else we can turn off in Elmo’s <ROOM>. */
export const LO_TO02 = "elmo_lo_to02";
/** There’s only one more thing to turn off. */
export const LO_TO03 = "elmo_lo_to03";
/** Try closing the refrigerator. */
export const LO_TO04 = "elmo_lo_to04";
/** To help take care of our planet, it is important to have parties for all of the cute little plants. Fortunately, I am quite the little party planner. Okay, where is my disco ball? */
export const PP_INTRO01 = ["grover_pp_intro01-01", 0.2, "grover_pp_intro01-02", 0.5, "grover_pp_intro01-03"];
/** No Grover! It means that we’re gonna grow plants that help the planet and keep it beautiful and healthy! */
export const PP_INTRO02 = ["abby_pp_intro02-01", 0.5, "abby_pp_intro02-02", 0.3, "abby_pp_intro02-03"];
/** Do not all plants help the planet? */
export const PP_INTRO03 = "grover_pp_intro03";
/** Yes, but some plants give bugs and birds healthy places to visit and live! Which helps the planet even more! */
export const PP_INTRO04 = ["abby_pp_intro04-01", 0.5, "abby_pp_intro04-02", 0.5, "abby_pp_intro04-03"];
/** Come on, let’s make some planters out of things we can find around our home! */
export const PP_CUSTOM01 = "abby_pp_custom01";
/** You can reuse all kinds of things to make planters. */
export const PP_CUSTOM02 = "abby_pp_custom02";
/** Now let’s decorate it! */
export const PP_CUSTOM03 = "abby_pp_custom03";
/** Ooo! */
export const PP_CUSTOM04 = "abby_pp_custom04";
/** This is gonna make a great planter. */
export const PP_CUSTOM05 = "abby_pp_custom05";
/** Huh! How magical! */
export const PP_CUSTOM06 = "abby_pp_custom06";
/** Looking good! */
export const PP_CUSTOM07 = "abby_pp_custom07";
/** <PROMPT> to choose an item to reuse. */
export const PP_CUSTOM_TO01 = "abby_pp_custom_to01";
/** <PROMPT> to choose a color. */
export const PP_CUSTOM_TO02 = "abby_pp_custom_to02";
/** <PROMPT> to choose a pattern. */
export const PP_CUSTOM_TO03 = "abby_pp_custom_to03";
/** <PROMPT> to choose a decoration. */
export const PP_CUSTOM_TO04 = "abby_pp_custom_to04";
/** <PROMPT> the arrow to see what’s next. */
export const PP_CUSTOM_TO05 = "abby_pp_custom_to05";
/** <PROMPT> on the tabs to see all the ways you can decorate your planter. */
export const PP_CUSTOM_TO06 = "abby_pp_custom_to06";
/** All done? Press the green check mark. */
export const PP_CUSTOM_TO07 = "abby_pp_custom_to07";
/** Okay, so now we have the party? */
export const PP_PLANTINGINTRO01 = "grover_pp_plantingintro01";
/** Now we plant some plants! Insects, like bees and butterflies, help flowers spread their pollen and that makes more plants and flowers! */
export const PP_PLANTINGINTRO02 = ["abby_pp_plantingintro02-01", 0.3, "abby_pp_plantingintro02-02", 0.3, "abby_pp_plantingintro02-03", 0.5, "abby_pp_plantingintro02-04"];
/** Choose a seed for your planter! */
export const PP_PLANTING01 = "abby_pp_planting01";
/** Now, let’s choose a seed for this pot! */
export const PP_PLANTING01B = "abby_pp_planting01b";

/** Zippity Zap! (WAND SFX) */
export const PP_PLANTING02 = "abby_pp_planting02";

/** Planting flowers is good for all kinds of bugs. */
export const PP_PLANTING03 = "abby_pp_planting03";
/** The more you plant, the more you help the bugs and birds! */
export const PP_PLANTING04 = "abby_pp_planting04";
/** Oh look, more garden friends! */
export const PP_PLANTING05 = "abby_pp_planting05";
/** Bees help plants and flowers grow. */
export const PP_PLANTING06 = "abby_pp_planting06";
/** Huh! I love planting! */
export const PP_PLANTING07 = "abby_pp_planting07";
/** Aren’t gardens great! */
export const PP_PLANTING08 = "abby_pp_planting08";
/** All done. What beautiful plants and flowers! */
export const PP_PLANTING09 = "abby_pp_planting09";
/** All done. Huh! Look at all our garden friends! */
export const PP_PLANTING10 = "abby_pp_planting10";
/** <PROMPT> on a seed. */
export const PP_PLANTING_TO01 = "abby_pp_planting_to01";
/** <PROMPT> on your planter to get started. */
export const PP_PLANTING_TO02 = "abby_pp_planting_to02";
/** Go ahead, keep planting more plants and flowers! */
export const PP_PLANTING_TO03 = "abby_pp_planting_to03";
/** You did it! */
export const BADGE01 = "grover_badge01";
/** Way to go! */
export const BADGEB01 = "grover_badgeb01";
/** Here is your Go Green, Clean Streets Badge! */
export const BADGE02 = "grover_badge02";
/** For helping pick up and recycle trash! */
export const BADGE02B = "oscar_badge02b";
/** Here is your Go Green, Conservation Badge! */
export const BADGE03 = "grover_badge03";
/** For helping turn everything off in Elmo’s house! */
export const BADGE03B = "elmo_badge03b";
/** Here is your Go Green, Planting Badge! */
export const BADGE04 = "grover_badge04";
/** For helping grow new plants for our garden friends! */
export const BADGE04B = "abby_badge04b";
/** Wow, you are so good at caring for our planet! */
export const BADGE05 = "grover_badge05";
/** Tap */
export const MM_PROMPT01 = "grover_mm_prompt01";
/** Click */
export const MM_PROMPT02 = "grover_mm_prompt02";
/** Tap */
export const LO_PROMPT01 = "elmo_lo_prompt01";
/** Click */
export const LO_PROMPT02 = "elmo_lo_prompt02";
/** Tap */
export const PP_PROMPT01 = "abby_pp_prompt01";
/** Click */
export const PP_PROMPT02 = "abby_pp_prompt02";
/** Tap */
export const TB_PROMPT01 = "oscar_tb_prompt01";
/** Click */
export const TB_PROMPT02 = "oscar_tb_prompt02";
/** Trash Blast! */
export const MM_ACTIVITY01 = "grover_mm_activity01";
/** Lights out! */
export const MM_ACTIVITY02 = "grover_mm_activity02";
/** Planter Party! */
export const MM_ACTIVITY03 = "grover_mm_activity03";
/** living room! */
export const LO_ROOM01 = "elmo_lo_room01";
/** bedroom! */
export const LO_ROOM02 = "elmo_lo_room02";
/** kitchen! */
export const LO_ROOM03 = "elmo_lo_room03";
/** bathroom! */
export const LO_ROOM04 = "elmo_lo_room04";
/** Paper */
export const TB_RECYCLE01 = "oscar_tb_recycle01";
/** Plastic and metal! */
export const TB_RECYCLE02 = "oscar_tb_recycle02";
/** A can. */
export const TB_RECYCLE03 = "oscar_tb_recycle03";
/** Old food. */
export const TB_RECYCLE04 = "oscar_tb_recycle04";
/** Compost */
export const TB_RECYCLE05 = "oscar_tb_recycle05";
/** An old bean can */
export const TB_TRASH01 = "oscar_tb_trash01";
/** An old tomato can */
export const TB_TRASH02 = "oscar_tb_trash02";
/** An old orange juice can */
export const TB_TRASH03 = "oscar_tb_trash03";
/** An empty water bottle */
export const TB_TRASH04 = "oscar_tb_trash04";
/** An empty milk jug */
export const TB_TRASH05 = "oscar_tb_trash05";
/** An empty peanut butter jar */
export const TB_TRASH06 = "oscar_tb_trash06";
/** A crumpled-up piece of paper */
export const TB_TRASH07 = "oscar_tb_trash07";
/** An old newspaper */
export const TB_TRASH08 = "oscar_tb_trash08";
/** An empty paper cup */
export const TB_TRASH09 = "oscar_tb_trash09";
/** An empty juice box */
export const TB_TRASH10 = "oscar_tb_trash10";
/** An old paper bag */
export const TB_TRASH11 = "oscar_tb_trash11";
/** An empty take-out container */
export const TB_TRASH12 = "oscar_tb_trash12";
/** A banana peel */
export const TB_TRASH13 = "oscar_tb_trash13";
/** An apple core */
export const TB_TRASH14 = "oscar_tb_trash14";
/** A corn cobb */
export const TB_TRASH15 = "oscar_tb_trash15";
/** An old piece of pretzel */
export const TB_TRASH16 = "oscar_tb_trash16";
/** A watermelon rind */
export const TB_TRASH17 = "oscar_tb_trash17";
/** Egg shells */
export const TB_TRASH18 = "oscar_tb_trash18";
/** The old bean can */
export const TB_TRASHB01 = "oscar_tb_trashb01";
/** The old tomato can */
export const TB_TRASHB02 = "oscar_tb_trashb02";
/** The old orange juice can */
export const TB_TRASHB03 = "oscar_tb_trashb03";
/** The empty water bottle */
export const TB_TRASHB04 = "oscar_tb_trashb04";
/** The empty milk jug */
export const TB_TRASHB05 = "oscar_tb_trashb05";
/** The empty peanut butter jar */
export const TB_TRASHB06 = "oscar_tb_trashb06";
/** The crumpled-up piece of paper */
export const TB_TRASHB07 = "oscar_tb_trashb07";
/** The old newspaper */
export const TB_TRASHB08 = "oscar_tb_trashb08";
/** The empty paper cup */
export const TB_TRASHB09 = "oscar_tb_trashb09";
/** The empty juice box */
export const TB_TRASHB10 = "oscar_tb_trashb10";
/** The old paper bag */
export const TB_TRASHB11 = "oscar_tb_trashb11";
/** The empty take-out container */
export const TB_TRASHB12 = "oscar_tb_trashb12";
/** The banana peel */
export const TB_TRASHB13 = "oscar_tb_trashb13";
/** The apple core */
export const TB_TRASHB14 = "oscar_tb_trashb14";
/** The corn cobb */
export const TB_TRASHB15 = "oscar_tb_trashb15";
/** The old piece of pretzel */
export const TB_TRASHB16 = "oscar_tb_trashb16";
/** The watermelon rind */
export const TB_TRASHB17 = "oscar_tb_trashb17";
/** The eggshell */
export const TB_TRASHB18 = "oscar_tb_trashb18";
/** A tomato plant! */
export const PP_PLANT01 = "abby_pp_plant01";
/** A Sunflower! */
export const PP_PLANT02 = "abby_pp_plant02";
/** A tulip! */
export const PP_PLANT03 = "abby_pp_plant03";
/** A yellow pepper plant! */
export const PP_PLANT04 = "abby_pp_plant04";
/** A red wildflower! */
export const PP_PLANT05 = "abby_pp_plant05";
/** A blue wildflower! */
export const PP_PLANT06 = "abby_pp_plant06";
/** old bean can. */
export const TB_TRASHC01 = "oscar_tb_trashc01";
/** old tomato can. */
export const TB_TRASHC02 = "oscar_tb_trashc02";
/** old orange juice can. */
export const TB_TRASHC03 = "oscar_tb_trashc03";
/** empty water bottle. */
export const TB_TRASHC04 = "oscar_tb_trashc04";
/** empty milk jug. */
export const TB_TRASHC05 = "oscar_tb_trashc05";
/** empty peanut butter jar */
export const TB_TRASHC06 = "oscar_tb_trashc06";
/** crumpled-up piece of paper. */
export const TB_TRASHC07 = "oscar_tb_trashc07";
/** old newspaper. */
export const TB_TRASHC08 = "oscar_tb_trashc08";
/** empty paper cup. */
export const TB_TRASHC09 = "oscar_tb_trashc09";
/** empty juice box. */
export const TB_TRASHC10 = "oscar_tb_trashc10";
/** old paper bag. */
export const TB_TRASHC11 = "oscar_tb_trashc11";
/** empty take-out container. */
export const TB_TRASHC12 = "oscar_tb_trashc12";
/** banana peel. */
export const TB_TRASHC13 = "oscar_tb_trashc13";
/** apple core. */
export const TB_TRASHC14 = "oscar_tb_trashc14";
/** corn cobb. */
export const TB_TRASHC15 = "oscar_tb_trashc15";
/** old piece of pretzel. */
export const TB_TRASHC16 = "oscar_tb_trashc16";
/** watermelon rind. */
export const TB_TRASHC17 = "oscar_tb_trashc17";
/** eggshell. */
export const TB_TRASHC18 = "oscar_tb_trashc18";
/** Tomato seeds! */
export const PP_SEED01 = "abby_pp_seed01";
/** Sunflower seeds! */
export const PP_SEED02 = "abby_pp_seed02";
/** Tulip seeds! */
export const PP_SEED03 = "abby_pp_seed03";
/** Yellow pepper seeds! */
export const PP_SEED04 = "abby_pp_seed04";
/** Wildflower seeds! */
export const PP_SEED05 = "abby_pp_seed05";
/** An old pail! */
export const PP_VESSEL01 = "abby_pp_vessel01";
/** An old rainboot! */
export const PP_VESSEL02 = "abby_pp_vessel02";
/** An empty coffee can! */
export const PP_VESSEL03 = "abby_pp_vessel03";
/** An old water can! */
export const PP_VESSEL04 = "abby_pp_vessel04";
/** An empty jar! */
export const PP_VESSEL05 = "abby_pp_vessel05";
/** Orange! */
export const PP_COLOR01 = "abby_pp_color01";
/** Yellow! */
export const PP_COLOR02 = "abby_pp_color02";
/** Blue! */
export const PP_COLOR03 = "abby_pp_color03";
/** Red! */
export const PP_COLOR04 = "abby_pp_color04";
/** Green! */
export const PP_COLOR05 = "abby_pp_color05";
/** Purple! */
export const PP_COLOR06 = "abby_pp_color06";

/**
 * get a random item from an array, re-randomizing only when you run out
 * could get the same twice in a row though
 */
export function randomExhaust<T>(parray: T[]) {
    const temparray = [...parray];
    shuffle(temparray);

    let last = temparray[0];

    function next(): T {
        if (temparray.length > 0) {
            last = temparray.shift()!;
            return last;
        }
        else {
            temparray.push(...parray.filter((it) => it !== last));
            shuffle(temparray);
            temparray.push(last);
            last = temparray.shift()!;
            shuffle(temparray);
            return last;
        }
    }

    return () => next();
}
